var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChaticonred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.032,
    height: 20,
    viewBox: "0 0 20.032 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1932",
    "data-name": "Group 1932",
    transform: "translate(472.665 -152.421)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3773",
    "data-name": "Path 3773",
    d: "M-472.652,172.421c-.006-.116-.013-.19-.013-.265q0-8.827.007-17.655a1.981,1.981,0,0,1,1.612-2.041,2.464,2.464,0,0,1,.491-.031c5.267,0,10.534.008,15.8-.009a2.042,2.042,0,0,1,2.08,1.629,2.711,2.711,0,0,1,.031.491c0,3.929-.014,7.857.011,11.786a2.084,2.084,0,0,1-2.139,2.133c-4.547-.021-9.094-.007-13.64-.012a.549.549,0,0,0-.43.175q-1.794,1.808-3.6,3.6C-472.5,172.284-472.562,172.338-472.652,172.421Zm16-15.977h-12v1.978h12Zm0,3h-12v1.979h12Zm-12.008,5h.3q3.05,0,6.1,0c.528,0,1.057-.021,1.585-.033q.013-.783.025-1.566c0-.13,0-.261,0-.393h-8.014Z",
    transform: "translate(0 0)",
    fill: "#d10a11"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChaticonred);
export default __webpack_public_path__ + "static/media/chaticonred.138cd62afaf9fcfd8601bba49cd218c3.svg";
export { ForwardRef as ReactComponent };